import { combineReducers } from 'redux';
import { type IModule } from 'redux-dynamic-modules';

import chatModuleApi from '../../features/ChatModule/data-layer/chatModuleApi';
import chatModuleReducer from '../../features/ChatModule/data-store/chatModuleSlice';
import serviceIdentityApi from '../../features/ServiceIdentity/data-layer/serviceIdentityApi';
import serviceIdentityReducer from '../../features/ServiceIdentity/data-store/serviceIdentitySlice';

import globalApi from './globalApis';
import globalReducer from './globalSlice';

export const SaviCopilotReducer = combineReducers({
  chatModule: chatModuleReducer,
  serviceIdentity: serviceIdentityReducer,
  global: globalReducer,
});

// Export middleware array directly for compatibility
export const saviCopilotMiddleware = [
  chatModuleApi.middleware,
  serviceIdentityApi.middleware,
  globalApi.middleware,
];

/**
 * Savi Copilot module for home page store
 * @description Creates and returns a Redux Dynamic Module for the Savi Copilot feature.
 * This module includes the combined Savi Copilot reducer and API reducers for the chat module
 * and global API endpoints.
 * @returns {IModule<unknown>} A Redux Dynamic Module containing the Savi Copilot reducers
 */
export function saviCopilotModule(): IModule<unknown> {
  return {
    id: 'saviCopilotModule',
    reducerMap: {
      savicopilot: SaviCopilotReducer,
      [chatModuleApi.reducerPath]: chatModuleApi.reducer,
      [serviceIdentityApi.reducerPath]: serviceIdentityApi.reducer,
      [globalApi.reducerPath]: globalApi.reducer,
    },
  };
}
